module.exports = __webpack_public_path__ + "assets/img/new.5c72a786.svg";